/*
 * @Author: 范向玲
 * @Date: 2022-10-08 16:16:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-06-11 17:10:41
 * @Description: 数据管理表格配置
 * @FilePath: \web\src\components\DataManagement\roleManagement\tableConfig.js
 */
const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '角色名称',
    dataIndex: 'roleName',
    // slots: { customRender: 'username', },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '角色详情',
    dataIndex: 'description',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '角色ID',
    dataIndex: 'roleId',
    ellipsis: true,
    align: 'center',
  },

  // {
  //   title: '行业类型',
  //   dataIndex: 'tradeType',
  //   slots: { customRender: 'tradeType', },
  //   ellipsis: true,
  //   align: 'center',
  // },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action' },
    align: 'center',
  },
];

export default tableConfig;
